import { GetContractsSaldoQueryDto } from '@ekt-group/general-purpose-api-interfaces';
import { queryOptions, useQuery } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { QueryConfig } from '@/lib/react-query';

export interface ContractBalance {
  id: number;
  code: string;
  amount: number;
  amountOver: number;
  dueDate: string | null;
  penalty: number;
  timestamp: string;
}

export const getContractsSaldo = (
  params: Partial<GetContractsSaldoQueryDto>,
): Promise<{
  data: ContractBalance[];
}> => {
  return httpService.get(`/contracts/saldo`, {
    params,
  });
};

export const geyContractsSaldoQueryOptions = (params: Partial<GetContractsSaldoQueryDto>) => {
  return queryOptions({
    queryKey: params ? ['contracts-saldo', { params }] : ['contracts-saldo'],
    queryFn: () => getContractsSaldo(params),
  });
};

type UseContractSaldoOptions = {
  params?: Partial<GetContractsSaldoQueryDto>;
  queryConfig?: QueryConfig<typeof geyContractsSaldoQueryOptions>;
};

export const useGetContractsSaldo = ({ queryConfig, params }: UseContractSaldoOptions) => {
  return useQuery({
    ...geyContractsSaldoQueryOptions(params),
    ...queryConfig,
  });
};
